import { createContext } from "react";

const DarkModeContext = createContext(false);

export default DarkModeContext;
